export default [
    {
      path: '/publications',
      name: 'publications-read',
      component: () => import('@/views/publications/publications-list/PublicationsList.vue'),
      meta: {
        resource: 'Publications',
        action: 'read',
      },
    },
   
    
    
  ]
  